// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Usa el mismo enfoque que el referral component */
:host {
  display: block;
  width: 100%;
  height: 100%;
  position: relative;
}

/* Estilo exacto del referral component para el background blanco */
.backgroundWhite {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  overflow-y: auto;
  z-index: 1;
}

.tutorials-wrapper {
  position: relative;
  width: 100%;
  height: auto;
  margin: 0;
  padding: 0;
  background-color: #ffffff;
}

.scrollable-area {
  width: 100%;
  height: 100%;
  overflow-y: visible;
  position: relative;
  background-color: #ffffff;
}

.main-container {
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
  background: #ffffff;
  min-height: 100vh;
}

.container {
  padding: 2rem;
  padding-top: 60px; /* Space for navbar */
}

.main-title {
  font-size: 1.7rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 2.3rem;
  padding-top: 0.7rem;
  margin-top: 0;
}

.subtitle {
  color: #666;
  font-size: 1.1rem;
  margin-bottom: 2rem;
}

.row {
  padding-bottom: 50px;
}

.video-card {
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 30px; /* Increase space between videos */
}

.video-card:hover {
  transform: translateY(-5px);
}

.video-container {
  position: relative;
  width: 100%;
  background-color: #000;
  border-radius: 8px 8px 0 0;
  overflow: hidden;
}

.video-info {
  padding: 1rem;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.video-title {
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #333;
  font-size: 1.1rem;
}

.video-description {
  color: #666;
  font-size: 0.9rem;
  margin-bottom: 0;
}

/* Force scrolling to work properly */
html, body {
  overflow: auto !important;
}

/* iPad - Estilos comunes para todos los iPads */
@media only screen and (min-device-width: 768px) and (max-device-width: 1366px) {
  .backgroundWhite {
    width: 100vw !important;
    max-width: 100vw !important;
    margin: 0 !important;
    left: 0 !important;
    right: 0 !important;
    overflow-y: auto !important;
    -webkit-overflow-scrolling: touch !important;
    position: absolute !important;
    z-index: 1 !important;
  }

  .container {
    width: 100% !important;
    max-width: none !important;
    padding: 2rem !important;
    padding-top: 60px !important;
    margin: 0 !important;
    box-sizing: border-box !important;
  }
  
  .main-title {
    width: 100% !important;
    font-size: 1.7rem !important;
    line-height: 1.3 !important;
  }
  
  .tutorials-wrapper {
    position: relative !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    width: 100% !important;
    height: auto !important;
    margin: 0 !important;
    background-color: #ffffff !important;
  }
  
  .scrollable-area {
    height: auto !important;
    overflow-y: visible !important;
    -webkit-overflow-scrolling: touch !important;
    background-color: #ffffff !important;
  }
  
  .main-container {
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    left: 0 !important;
    right: 0 !important;
    overflow-y: visible !important;
    min-height: 100% !important;
    background: #ffffff !important;
  }
}

/* Mobile pequeño */
@media (max-width: 576px) {
  .container {
    padding: 0.5rem;
    padding-top: 60px;
  }
  
  .main-title {
    font-size: 1.5rem;
    margin-top: 0;
  }
  
  .subtitle {
    font-size: 1rem;
  }
}

/* Hack específico para Safari en todos los iPads */
@supports (-webkit-touch-callout: none) {
  @media only screen 
    and (min-device-width: 768px) 
    and (max-device-width: 1366px) {
    
    .backgroundWhite {
      transform: translateZ(0);
      backface-visibility: hidden;
      height: auto !important;
      min-height: 101% !important;
    }
    
    div.main-container {
      transform: translateZ(0);
      backface-visibility: hidden;
      height: auto !important;
      width: 100% !important;
      background-color: #ffffff !important;
    }
    
    /* Mejoras para scroll en iPadOS */
    body, html {
      height: auto !important;
      overflow: auto !important;
      position: relative !important;
    }
    
    /* Arreglar problema con el scroll en iPadOS */
    .scrollable-area {
      -webkit-overflow-scrolling: touch !important;
      height: auto !important;
      min-height: 100vh !important;
      background-color: #ffffff !important;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/components/investment-tutorials/investment-tutorials.component.css"],"names":[],"mappings":"AAAA,mDAAmD;AACnD;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,mEAAmE;AACnE;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iBAAiB,EAAE,qBAAqB;AAC1C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,+BAA+B;EAC/B,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAE,kCAAkC;AACzD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,yBAAyB;AAC3B;;AAEA,gDAAgD;AAChD;EACE;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;IAC3B,4CAA4C;IAC5C,6BAA6B;IAC7B,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,wBAAwB;IACxB,4BAA4B;IAC5B,oBAAoB;IACpB,iCAAiC;EACnC;;EAEA;IACE,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;IAC7B,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,oBAAoB;IACpB,oCAAoC;EACtC;;EAEA;IACE,uBAAuB;IACvB,8BAA8B;IAC9B,4CAA4C;IAC5C,oCAAoC;EACtC;;EAEA;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;IAC9B,2BAA2B;IAC3B,8BAA8B;EAChC;AACF;;AAEA,mBAAmB;AACnB;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,mDAAmD;AACnD;EACE;;;;IAIE;MAEE,wBAAwB;MAExB,2BAA2B;MAC3B,uBAAuB;MACvB,2BAA2B;IAC7B;;IAEA;MAEE,wBAAwB;MAExB,2BAA2B;MAC3B,uBAAuB;MACvB,sBAAsB;MACtB,oCAAoC;IACtC;;IAEA,kCAAkC;IAClC;MACE,uBAAuB;MACvB,yBAAyB;MACzB,6BAA6B;IAC/B;;IAEA,8CAA8C;IAC9C;MACE,4CAA4C;MAC5C,uBAAuB;MACvB,4BAA4B;MAC5B,oCAAoC;IACtC;EACF;AACF","sourcesContent":["/* Usa el mismo enfoque que el referral component */\n:host {\n  display: block;\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n\n/* Estilo exacto del referral component para el background blanco */\n.backgroundWhite {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #ffffff;\n  overflow-y: auto;\n  z-index: 1;\n}\n\n.tutorials-wrapper {\n  position: relative;\n  width: 100%;\n  height: auto;\n  margin: 0;\n  padding: 0;\n  background-color: #ffffff;\n}\n\n.scrollable-area {\n  width: 100%;\n  height: 100%;\n  overflow-y: visible;\n  position: relative;\n  background-color: #ffffff;\n}\n\n.main-container {\n  width: 100%;\n  max-width: 100%;\n  margin: 0;\n  padding: 0;\n  background: #ffffff;\n  min-height: 100vh;\n}\n\n.container {\n  padding: 2rem;\n  padding-top: 60px; /* Space for navbar */\n}\n\n.main-title {\n  font-size: 1.7rem;\n  font-weight: 700;\n  color: #333;\n  margin-bottom: 2.3rem;\n  padding-top: 0.7rem;\n  margin-top: 0;\n}\n\n.subtitle {\n  color: #666;\n  font-size: 1.1rem;\n  margin-bottom: 2rem;\n}\n\n.row {\n  padding-bottom: 50px;\n}\n\n.video-card {\n  background-color: white;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s ease;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 30px; /* Increase space between videos */\n}\n\n.video-card:hover {\n  transform: translateY(-5px);\n}\n\n.video-container {\n  position: relative;\n  width: 100%;\n  background-color: #000;\n  border-radius: 8px 8px 0 0;\n  overflow: hidden;\n}\n\n.video-info {\n  padding: 1rem;\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.video-title {\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n  color: #333;\n  font-size: 1.1rem;\n}\n\n.video-description {\n  color: #666;\n  font-size: 0.9rem;\n  margin-bottom: 0;\n}\n\n/* Force scrolling to work properly */\nhtml, body {\n  overflow: auto !important;\n}\n\n/* iPad - Estilos comunes para todos los iPads */\n@media only screen and (min-device-width: 768px) and (max-device-width: 1366px) {\n  .backgroundWhite {\n    width: 100vw !important;\n    max-width: 100vw !important;\n    margin: 0 !important;\n    left: 0 !important;\n    right: 0 !important;\n    overflow-y: auto !important;\n    -webkit-overflow-scrolling: touch !important;\n    position: absolute !important;\n    z-index: 1 !important;\n  }\n\n  .container {\n    width: 100% !important;\n    max-width: none !important;\n    padding: 2rem !important;\n    padding-top: 60px !important;\n    margin: 0 !important;\n    box-sizing: border-box !important;\n  }\n  \n  .main-title {\n    width: 100% !important;\n    font-size: 1.7rem !important;\n    line-height: 1.3 !important;\n  }\n  \n  .tutorials-wrapper {\n    position: relative !important;\n    top: 0 !important;\n    left: 0 !important;\n    right: 0 !important;\n    bottom: 0 !important;\n    width: 100% !important;\n    height: auto !important;\n    margin: 0 !important;\n    background-color: #ffffff !important;\n  }\n  \n  .scrollable-area {\n    height: auto !important;\n    overflow-y: visible !important;\n    -webkit-overflow-scrolling: touch !important;\n    background-color: #ffffff !important;\n  }\n  \n  .main-container {\n    width: 100% !important;\n    max-width: 100% !important;\n    margin: 0 !important;\n    left: 0 !important;\n    right: 0 !important;\n    overflow-y: visible !important;\n    min-height: 100% !important;\n    background: #ffffff !important;\n  }\n}\n\n/* Mobile pequeño */\n@media (max-width: 576px) {\n  .container {\n    padding: 0.5rem;\n    padding-top: 60px;\n  }\n  \n  .main-title {\n    font-size: 1.5rem;\n    margin-top: 0;\n  }\n  \n  .subtitle {\n    font-size: 1rem;\n  }\n}\n\n/* Hack específico para Safari en todos los iPads */\n@supports (-webkit-touch-callout: none) {\n  @media only screen \n    and (min-device-width: 768px) \n    and (max-device-width: 1366px) {\n    \n    .backgroundWhite {\n      -webkit-transform: translateZ(0);\n      transform: translateZ(0);\n      -webkit-backface-visibility: hidden;\n      backface-visibility: hidden;\n      height: auto !important;\n      min-height: 101% !important;\n    }\n    \n    div.main-container {\n      -webkit-transform: translateZ(0);\n      transform: translateZ(0);\n      -webkit-backface-visibility: hidden;\n      backface-visibility: hidden;\n      height: auto !important;\n      width: 100% !important;\n      background-color: #ffffff !important;\n    }\n    \n    /* Mejoras para scroll en iPadOS */\n    body, html {\n      height: auto !important;\n      overflow: auto !important;\n      position: relative !important;\n    }\n    \n    /* Arreglar problema con el scroll en iPadOS */\n    .scrollable-area {\n      -webkit-overflow-scrolling: touch !important;\n      height: auto !important;\n      min-height: 100vh !important;\n      background-color: #ffffff !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
